import { Component, Mixins } from 'vue-property-decorator'

import ModalDialogHelper from '@/mixins/ModalDialogHelper'

const InvitesManagePanel = () => import('@/components/invites/InvitesManagePanel.vue')

@Component
export default class ShowInvitesMixin extends Mixins(ModalDialogHelper)
{
	showManageInvites()
	{
		// @ts-ignore
		const modal = this.$buefy.modal.open({
			// parent: this,
			component: InvitesManagePanel,
			hasModalCard: true
		})

		this.bringToFront(modal)
	}
}
